(function(){
    'use strict'

    angular
    .module('app.reportes')
    .controller('HistoricoSalarios', HistoricoSalarios);

    HistoricoSalarios.$inject = ['$scope', '$animationsSrv', 'TiposPlanillaService', 'logger', 'UserInfoService', 'moment', 'ReportesService', 'EmpleadosService'];

    function HistoricoSalarios($scope, $animationsSrv, TiposPlanillaService, logger, UserInfoService, moment, ReportesService, EmpleadosService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.tiposPlanilla = [];
        vm.periodos = [];

        vm.filterData = [];
        vm.empleados = [];

        vm.historicoSalarios = {
            companiaId: UserInfoService.getCompaniaId(),
            tipoPlanillaId: -1,
            periodoDesde: -1,
            periodoHasta: -1,
            empleadoId: '',
            empleadoNombre: ''
        };

        vm.busquedaEmpleado = {
            puestoId: -1,
            departamentoId: -1,
            tipoPlanillaId: -1,
            nombre: '',
            identificacion: '',
            companiaId: UserInfoService.getCompaniaId(),
            estado: -1
        };

        vm.title = 'Historico de Salarios';

        getTiposPlanilla();
        getPeriodos();

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAllForCalendarizacion(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                tiposPlanilla.forEach(tipo => {
                    tipo.fechaInicio = moment(tipo.fechaInicio).toDate();
                    tipo.fechaFinal = moment(tipo.fechaFinal).toDate();
                });
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function getPeriodos(){
            var promise = EmpleadosService.getPromedioMensualPeriodos()
            .then(function(periodos){
                vm.periodos = periodos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los periodos.');
            }); 
            
            return promise;
        };

        vm.periodoDesdeChange = function(){
            validatePeriodoDesde();         
        };

        vm.periodoHastaChange = function(){
            validatePeriodoHasta();         
        };
        
        function validatePeriodoDesde(){
            if(vm.historicoSalarios.periodoDesde == -1){
                $scope.historicoSalariosForm.periodoDesde.$setValidity("different", false);
                return false;
            }
            else{
                $scope.historicoSalariosForm.periodoDesde.$setValidity("different", true);
            }

            return true;
        };

        function validatePeriodoHasta(){
            if(vm.historicoSalarios.periodoHasta == -1){
                $scope.historicoSalariosForm.periodoHasta.$setValidity("different", false);
                return false;
            }
            else{
                $scope.historicoSalariosForm.periodoHasta.$setValidity("different", true);
            }

            if(vm.historicoSalarios.periodoHasta < vm.historicoSalarios.periodoDesde){
                $scope.historicoSalariosForm.periodoHasta.$setValidity("lessThan", false);
                return false;
            }
            else{
                $scope.historicoSalariosForm.periodoHasta.$setValidity("lessThan", true);
            }

            return true;

        };

        function doFormValidations(){
            validatePeriodoDesde();
            validatePeriodoHasta();
        };

        vm.generar = function() {
            var promise = null;
                
            $scope.submitted = true;

            doFormValidations();

            if($scope.historicoSalariosForm.$valid){
                promise = ReportesService.getHistoricoSalarios(vm.historicoSalarios.tipoPlanillaId, vm.historicoSalarios.empleadoId, vm.historicoSalarios.periodoDesde, vm.historicoSalarios.periodoHasta);

                promise
                .then(function(response){
                    logger.success('Reporte Generado con éxito.');
                })
                .catch(function(error){
                    switch (error.status) {
                        case 500:
                            logger.error(`Hubo un error al generar el reporte: ${error.data.Message}`);
                            break;
                        case 401:
                            logger.error('La sessión ha terminado.');
                            break;
                        default:
                            logger.error('Hubo un error al generar el reporte');
                            break;
                    }
                }); 
            }
        };
        
        vm.limpiar = function(){
            $scope.submitted = false;
            // Reset the form model.
            vm.historicoSalarios = {
                tipoPlanillaId: -1,
                periodoDesde: -1,
                periodoHasta: -1
            };
            
            // Set back to pristine.
            $scope.historicoSalariosForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.historicoSalariosForm.$setUntouched();
        }

        vm.openModalEmpleados = function(){
            if(vm.empleados.length > 0){
                $('#myModalEmpleados').modal('toggle');   
            }
            else{
                var promise = EmpleadosService.getAll(vm.busquedaEmpleado);

                promise
                .then(function(result){
                    vm.empleados = result.data;
                    $('#myModalEmpleados').modal('toggle'); 
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sessión ha terminado.');
                            break;
                    
                        default:
                            logger.error('Error al obtener los empleados.');
                            break;
                    }
                });
            }
             
        };

        vm.filterEmpleados = function(){
            vm.filterData = vm.empleados.filter(function(g) {
                return (g.id.toString().indexOf(vm.busquedaEmpleado.id) >= 0 || !vm.busquedaEmpleado.id) && 
                (g.nombre.toLowerCase().indexOf(vm.busquedaEmpleado.nombre.toLowerCase()) >= 0 || !vm.busquedaEmpleado.nombre);
            }).slice(0, 100);
        };

        vm.seleccionarEmpleado = function(e){
            vm.historicoSalarios.empleadoId = e.id;
            vm.historicoSalarios.empleadoNombre = e.nombre;
            $('#myModalEmpleados').modal('toggle');   
        };

    }
})();